'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('adDefaultStat', {
      url: '/adDefaultStat',
      template: '<ad-default-stat></ad-default-stat>'
    });
}



// WEBPACK FOOTER //
// ./client/app/adDefaultStat/adDefaultStat.routes.js